// filterView/parts/conditionRows.js — a list of condition rows plus "+ Bedingung hinzufügen" (plan
// documents_admin-search, phase filter-varianten): builder B shows all conditions in it, the search bar A the ones that
// are not search bar or chip ("Weitere Filter"). The caller decides which conditions; render(conditions, problems)
// reconciles the rows by condition id — new ones added, gone ones taken down, the others only updated and moved only
// when out of place (moving the row that holds focus would blur it).
//
// createConditionRows({ schema, store, addField }) → { element, render, destroy }
//   addField: field of a new row; problems: Map condition id → validate() reason

import { createDisposers } from '../../core/disposers.js';
import { addCondition } from '../conditionSet.js';
import { createConditionRow } from './conditionRow.js';

export function createConditionRows({ schema, store, addField }) {
    const disposers = createDisposers();

    const element = document.createElement('div');
    element.className = 'topo2-filterview-rowsblock';
    const rowsEl = document.createElement('div');
    rowsEl.className = 'topo2-filterview-rows';
    const add = document.createElement('button');
    add.type = 'button';
    add.className = 'topo2-btn topo2-btn--outline topo2-btn--bar topo2-btn--extrasmall topo2-filterview-add';
    add.textContent = schema.texts.FILTER_VIEW_ADD;
    element.append(rowsEl, add);

    const rows = new Map();   // condition id → row
    disposers.add(() => {
        for (const row of rows.values()) {
            row.destroy();
        }
        rows.clear();
    });

    const render = (conditions, problems) => {
        const ids = new Set(conditions.map((c) => c.id));
        for (const [id, row] of rows) {
            if (!ids.has(id)) {
                row.destroy();
                row.element.remove();
                rows.delete(id);
            }
        }
        conditions.forEach((condition, index) => {
            let row = rows.get(condition.id);
            if (!row) {
                row = createConditionRow({ schema, store, id: condition.id });
                rows.set(condition.id, row);
            }
            row.update(condition, problems.get(condition.id) ?? null);
            if (rowsEl.children[index] !== row.element) {
                rowsEl.insertBefore(row.element, rowsEl.children[index] ?? null);
            }
        });
    };

    const onAdd = () => {
        const next = store.set((set) => addCondition(set, schema, { field: addField }));
        rows.get(next.conditions[next.conditions.length - 1].id)?.focus();
    };
    add.addEventListener('click', onAdd);
    disposers.add(() => add.removeEventListener('click', onAdd));

    return { element, render, destroy: () => disposers.dispose() };
}
